import { render, staticRenderFns } from "./index.vue?vue&type=template&id=299d09bb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=299d09bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d09bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299d09bb')) {
      api.createRecord('299d09bb', component.options)
    } else {
      api.reload('299d09bb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=299d09bb&scoped=true", function () {
      api.rerender('299d09bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/ad/index.vue"
export default component.exports